var exports = {
  "A": "labelDescriptionTooltip__uFw7Q4",
  "u": "hiddenTooltip__Y6Qqij",
};

module.exports = exports;
